import { render } from "./YoutubeStream.vue?vue&type=template&id=1898bba8"
import script from "./YoutubeStream.vue?vue&type=script&lang=js"
export * from "./YoutubeStream.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Workspaces\\livetv\\vuefront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__